import { defineMessage } from 'react-intl';
import { getDisplayInformation } from './get-display-information';

const unknownInsuranceProvider = defineMessage({
  description: 'dataDrivenLogos.unknownMarketplace',
  defaultMessage: 'Unknown Marketplace',
  id: 'KtHZZi',
});

export const GetInsuranceProviderDisplayName = (insuranceProviderId) => {
  const displayInformation = getDisplayInformation({ insuranceProviderId }) || {};
  if (displayInformation?.messageDescriptor) {
    return displayInformation.messageDescriptor;
  }

  if (displayInformation?.name) {
    // Return inline message descriptor to avoid formatjs/no-useless-message lint error
    return { id: 'insuranceProvider.dynamic', defaultMessage: displayInformation.name };
  }
  return unknownInsuranceProvider;
};
